import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import swal from 'sweetalert2';
import { environment } from '../../../../environments/environment';
import { SessionTimerService } from '../../../core/services/session-timer.service';

@Component({
  selector: 'app-identity-proof',
  templateUrl: './identity-proof.component.html',
  styleUrls: ['./identity-proof.component.scss'],
})
export class IdentityProofComponent implements OnInit {

  baseUrl!: string;
  constructor(private router: Router, private sessionTimerService: SessionTimerService, private spinner: NgxSpinnerService) {
    this.baseUrl = environment.apiUrl + 'assistmodule/v1/createUserProfile';
  }
  ngOnInit(): void {
    this.spinner.hide();
    //this.sessionTimerService.resumeTimer();
  }

  ProceedToDocUpload(response: any) {
    this.spinner.show();
    console.log(response, "pan");
    if (response['error'] == null) {
      //swal.fire(response['data']['response_msg']);
      swal.fire({
        text: '' + response['data']['response_msg'],
        //icon: 'info',
        confirmButtonText: 'OK'
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigateByUrl('/assist-journey/address-proof');
        }
      });

    } else {
      swal.fire(response['error']['response_msg']);
      if (response['error']['response_summary'] == "AUTO_ID_VERIFICATION_DENIED") {
        this.spinner.hide();
        return this.router.navigateByUrl('/assist-journey/address-proof');
      }
      else {
        this.router.navigateByUrl('/assist-journey/identity-proof');
      }
    }
    this.spinner.hide();
  }
}
